<template>
  <div class="ab-ui-input">
    <label v-if="label" class="ab-ui-input__label">
      {{ label }}
    </label>
    <div class="ab-ui-input__control" :class="{ 'ab-ui-input__control--error': error }">
      <input
        v-bind="$attrs"
        class="ab-ui-input__native"
        :type="type"
        :placeholder="placeholder"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
    </div>
    <p v-if="error" class="ab-ui-input__error">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'AbUiInput',
  inheritAttrs: false,
  props: {
    value: [String, Number],
    label: String,
    placeholder: String,
    type: {
      type: String,
      default: 'text',
    },
    error: String,
  },
}
</script>

<style scoped>
.ab-ui-input {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ab-ui-input__label {
  font-size: 12px;
  color: #555;
}

.ab-ui-input__control {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  padding: 8px 10px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.ab-ui-input__control--error {
  border-color: #f44336;
}

.ab-ui-input__native {
  border: none;
  outline: none;
  width: 100%;
  font-size: 13px;
  background: transparent;
}

.ab-ui-input__native::placeholder {
  color: #b0b0b0;
}

.ab-ui-input__error {
  font-size: 11px;
  color: #f44336;
  margin: 0;
}
</style>

